<template>
  <div id="app">
    <Header></Header>
    <router-view></router-view>
    <Bottom></Bottom>
  </div>
</template>

<script>
import Header from '@/components/Header'
import Bottom from '@/components/Bottom'
export default {
  name: "App",
  data(){
    return {
      
    }
  },
  components: {
    Header,
    Bottom
  }
};
</script>

<style>
* {
  margin: 0;
  padding: 0;
}
img {
  vertical-align: middle;
}
#app {
  font-family: "Avenir", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  /* text-align: center; */
  color: #2c3e50;
  /* margin-top: 60px; */
}
a {
    text-decoration: none;
    color: black;
}
/*正常的未被访问过的链接*/
a:link {
    text-decoration: none;
}
/*已经访问过的链接*/
a:visited {
    text-decoration: none;
}
/*鼠标划过(停留)的链接*/
a:hover {
    text-decoration: none;
}
/* 正在点击的链接，鼠标在元素上按下还没有松开*/
a:active {
    text-decoration: none;
}
/* 获得焦点的时候 鼠标松开时显示的颜色*/
a:focus {
    text-decoration: none;
}
p {
  margin: 0;
}

h3 {
  margin: 0;
  /* font-size: 14px; */
}
h4 {
  margin: 0;
  /* font-size: 13px; */
}
h1 {
  margin: 0;
  /* font-size: 24px; */
}
h2 {
  margin: 0;
  /* font-size: 18px; */
}
</style>



// WEBPACK FOOTER //
// src/App.vue